import React, { useState, useEffect } from "react";
import settingsService from "../../../Modules/Services/settings.service";
import "./ManageSettings.css";

const ManageSettings = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [initialPhoneNumber, setInitialPhoneNumber] = useState("");
  const [orderAccepting, setOrderAccepting] = useState(true);
  const [initialOrderAccepting, setInitialOrderAccepting] = useState(true);
  const [disabledReason, setDisabledReason] = useState("");
  const [initialDisabledReason, setInitialDisabledReason] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");

  const reasonOptions = [
    "Закрыты",
    "Технические работы",
    "Большая нагрузка",
    "Перерыв",
    "Кухня перегружена",
  ];

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setIsLoading(true);
        const [phoneData, orderData] = await Promise.all([
          settingsService.getPhoneNumber().catch(() => ({ phoneNumber: "" })),
          settingsService.getOrderStatus().catch(() => ({
            accepting: true,
            reason: null,
          })),
        ]);

        setPhoneNumber(phoneData.phoneNumber || "");
        setInitialPhoneNumber(phoneData.phoneNumber || "");

        setOrderAccepting(Boolean(orderData.accepting));
        setInitialOrderAccepting(Boolean(orderData.accepting));
        setDisabledReason(orderData.reason || "");
        setInitialDisabledReason(orderData.reason || "");
        setError(null);
      } catch (err) {
        setError("Не удалось загрузить номер телефона.");
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      setSuccessMessage("");
      setError(null);
      if (phoneNumber !== initialPhoneNumber) {
        await settingsService.updatePhoneNumber(phoneNumber);
        setInitialPhoneNumber(phoneNumber);
      }

      const effectiveReason = orderAccepting ? "" : disabledReason;
      const orderChanged =
        orderAccepting !== initialOrderAccepting ||
        effectiveReason !== initialDisabledReason;
      if (orderChanged) {
        await settingsService.updateOrderStatus({
          accepting: orderAccepting,
          reason: effectiveReason,
        });
        setInitialOrderAccepting(orderAccepting);
        setInitialDisabledReason(effectiveReason);
      }

      setSuccessMessage("Номер телефона успешно обновлен!");
    } catch (err) {
      setError("Не удалось обновить номер телефона.");
      console.error(err);
    }
  };

  const effectiveReason = orderAccepting ? "" : disabledReason;
  const isChanged =
    phoneNumber !== initialPhoneNumber ||
    orderAccepting !== initialOrderAccepting ||
    effectiveReason !== initialDisabledReason;

  if (isLoading) {
    return <div>Загрузка...</div>;
  }

  return (
    <div className="ManageSettings">
      <h2>Управление настройками</h2>
      <form onSubmit={handleUpdate} className="SettingsForm">
        <div className="FormGroup">
          <label htmlFor="phoneNumber">Номер телефона для WhatsApp</label>
          <input
            type="text"
            id="phoneNumber"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            className="SettingsInput"
          />
        </div>

        <div className="FormGroup">
          <label>Приём заказов</label>
          <div className="ToggleRow">
            <label className="Toggle">
              <input
                type="checkbox"
                checked={orderAccepting}
                onChange={(e) => setOrderAccepting(e.target.checked)}
              />
              <span className="ToggleSlider" />
            </label>
            <div className="ToggleText">
              {orderAccepting ? "Включён" : "Отключён"}
            </div>
          </div>
        </div>

        {!orderAccepting && (
          <div className="FormGroup">
            <label htmlFor="disabledReason">Причина отключения</label>
            <select
              id="disabledReason"
              className="SettingsInput"
              value={disabledReason}
              onChange={(e) => setDisabledReason(e.target.value)}
            >
              <option value="">— выберите причину —</option>
              {reasonOptions.map((r) => (
                <option key={r} value={r}>
                  {r}
                </option>
              ))}
            </select>
          </div>
        )}

        {error && <p className="ErrorMessage">{error}</p>}
        {successMessage && <p className="SuccessMessage">{successMessage}</p>}
        <button type="submit" disabled={!isChanged} className="SaveButton">
          Сохранить изменения
        </button>
      </form>
    </div>
  );
};

export default ManageSettings;
